import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 28 Feb 2026 4:24 AM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.xklq75fTlfgdVZDmotVOqjmj5TF_fFp3dg7oJWoECPm27zY3Hbbp8VWFflnXaE31g_R9PnnX3auDGEHpPse67p6UqVerkVwg5z6WsGhNOBtvc7Ymg9V4uC1BSzu_ARnzV39JLLVm_VZ6wuSXbqk5QyvXInL9rQLbamjtm1i0eMRsmAF_UMkoAFwAu8ubeKr2E8QRxMV6Zd5K3MkqxDZRGWnojYRsqQFTt9EFvTv3tTtiAH7ka8F4ctyL74R4kONeeUW-z7SCOu6lx1UTJ97xJ6ErUSgAiSsB5VRJMeaZ1AId9q_wE_o8_zfyYVZ334Hs-Se9BbAGKHl6qIAD-GpWRcCqyLtduB2HcA",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-03-07T03:23:39.452195Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2026-02-28T03:23:31+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.xklq75fTlfgdVZDmotVOqjmj5TF_fFp3dg7oJWoECPm27zY3Hbbp8VWFflnXaE31g_R9PnnX3auDGEHpPse67p6UqVerkVwg5z6WsGhNOBtvc7Ymg9V4uC1BSzu_ARnzV39JLLVm_VZ6wuSXbqk5QyvXInL9rQLbamjtm1i0eMRsmAF_UMkoAFwAu8ubeKr2E8QRxMV6Zd5K3MkqxDZRGWnojYRsqQFTt9EFvTv3tTtiAH7ka8F4ctyL74R4kONeeUW-z7SCOu6lx1UTJ97xJ6ErUSgAiSsB5VRJMeaZ1AId9q_wE_o8_zfyYVZ334Hs-Se9BbAGKHl6qIAD-GpWRcCqyLtduB2HcA'

// {
//   "access_token": "v2.local.5c_Bq9GEYWEvB7NeCzyJ8JBEA7PVqXH-JEJfFX2nCwrd-K15GaPF2Mvk1zAloSK-IHCBwxQORKVujW5lkHJawuroSkqJM0FFNAUHVsCSFlDRAPAk3z0P6EvLHbfyMBCFLNAu0_tWJVXT2tWf9GJ6VmmyLNtla0SH1OHcIlMzy-XcysTThO44oMfzdMNWo0DtK7Jo-5-1-4ssP8IRaWEhsbD1Ng7PHy_g66rx9y1uiqZfrlXQJ3PkFg43dYSOiiFRMiIVntPlO_vkfRASGrRaMG1ZYJ-bcAM1XFqchY5N78FS1GMZhQ-nqvD-HWtv1QJWEy9YPNAPNqSpXDi50yQ7gmA7zOI3",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-03-07T03:24:51.221301Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2026-02-28T03:24:45+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.5c_Bq9GEYWEvB7NeCzyJ8JBEA7PVqXH-JEJfFX2nCwrd-K15GaPF2Mvk1zAloSK-IHCBwxQORKVujW5lkHJawuroSkqJM0FFNAUHVsCSFlDRAPAk3z0P6EvLHbfyMBCFLNAu0_tWJVXT2tWf9GJ6VmmyLNtla0SH1OHcIlMzy-XcysTThO44oMfzdMNWo0DtK7Jo-5-1-4ssP8IRaWEhsbD1Ng7PHy_g66rx9y1uiqZfrlXQJ3PkFg43dYSOiiFRMiIVntPlO_vkfRASGrRaMG1ZYJ-bcAM1XFqchY5N78FS1GMZhQ-nqvD-HWtv1QJWEy9YPNAPNqSpXDi50yQ7gmA7zOI3'

// {
//   "access_token": "v2.local.4to-3kTK0LvZok2e4Py5AcP-zMsTgCQDtIfvFcOzD4K2iM1H48BWJSazLC4AT17IYWy99Sl3Hw0xIk1FhePNk5nZjtcT0cDUaiWh4WW6i941SEHFLRfQqNuOYs556Ee8QQ0i9WUyiGL12R6AlvtFabrE6S38atVctsVJG1v8r4Hz8bBx9wJA7gO0f9_88qZr04cbMGaLWFuetX322jtHd02E_xg56f3a4kOIisP2G7gl6p5y17CerPPTC-OuO1BCMGORAT3NjCyvhODFYKtmy1pugELrWDXRI7rMOGbzSKKLcz90REkyuPP3rYmSUiGba4OlmM0-c7Ne5FL7c7nGrMotiV8",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-03-07T03:25:56.977661Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.4to-3kTK0LvZok2e4Py5AcP-zMsTgCQDtIfvFcOzD4K2iM1H48BWJSazLC4AT17IYWy99Sl3Hw0xIk1FhePNk5nZjtcT0cDUaiWh4WW6i941SEHFLRfQqNuOYs556Ee8QQ0i9WUyiGL12R6AlvtFabrE6S38atVctsVJG1v8r4Hz8bBx9wJA7gO0f9_88qZr04cbMGaLWFuetX322jtHd02E_xg56f3a4kOIisP2G7gl6p5y17CerPPTC-OuO1BCMGORAT3NjCyvhODFYKtmy1pugELrWDXRI7rMOGbzSKKLcz90REkyuPP3rYmSUiGba4OlmM0-c7Ne5FL7c7nGrMotiV8'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
